import { PageRoutes } from '../enums/enums';

export const factSheetSections = [
  { key: 'overview', dictKey: 'globalFactsheet', to: PageRoutes.PUBLIC_FACTSHEET_INDEX },
  { key: 'performance', dictKey: 'fsovP2Performance', to: PageRoutes.PUBLIC_FACTSHEET_PERFORMANCE },
  { key: 'facex', dictKey: 'globalFactsheetSectionFacex', to: PageRoutes.PUBLIC_FACTSHEET_FACTOR_EXPOSURE },
  { key: 'secex', dictKey: 'globalFactsheetSectionSecex', to: PageRoutes.PUBLIC_FACTSHEET_SECTOR_EXPOSURE },
  { key: 'attribution', dictKey: 'fsovP2Attribution', to: PageRoutes.PUBLIC_FACTSHEET_PERFORMANCE_ATTRIBUTION },
  { key: 'delta', dictKey: 'globalFactsheetSectionDelta', to: PageRoutes.PUBLIC_FACTSHEET_DELTA },
  { key: 'esg', dictKey: 'globalFactsheetSectionEsg', to: PageRoutes.PUBLIC_FACTSHEET_ESG },
];

